export default {"src":"/_next/static/media/weth.9999c9b4.svg","height":24,"width":24};